/* Native Shopify contact submission; this element only manages optional fields. */
if (!customElements.get('fate-contact-form')) {
  customElements.define('fate-contact-form', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const orderField = this.querySelector('[data-order-field]');
      if (!orderField) return;
      const orderInput = orderField.querySelector('input');
      const syncOrder = () => {
        const hasOrder = this.querySelector('input[name="contact[Tienes pedido]"]:checked')?.value === 'Sí';
        orderField.hidden = !hasOrder;
        orderInput.required = hasOrder;
        orderInput.disabled = !hasOrder;
      };
      this.querySelectorAll('input[name="contact[Tienes pedido]"]').forEach(input => {
        input.addEventListener('change', syncOrder, { signal: this.controller.signal });
      });
      window.addEventListener('pageshow', syncOrder, { signal: this.controller.signal });
      syncOrder();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
